import React, { useState } from 'react'
import { useHistory, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import PaymentsList from '../components/PaymentsList'
import { makeGetOrder } from '../../../selectors/order'
import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'
import { centsToDollars } from '../../../utils/formatters'
import ConfirmDialog from '../../../components/dialog/ConfirmDialog'
import PaymentActionDialog from '../components/PaymentActionDialog'
import useRemovePayment from '../hooks/useRemovePayment'
import filterValidPayments from '../../../utils/filterValidPayments'

const PaymentsListContainer = ({
  orderId,
  paymentId,
  remainingBalanceInCents,
  payments,
  dialogClassName
}) => {
  const history = useHistory()
  const [cancel, setConfirmCancel] = useState(false)
  const [showActions, setShowActions] = useState(false)
  const [selectedPayment, setSelectedPayment] = useState()
  const [removePayment, { loading, failed, success }] = useRemovePayment()

  const handleOnSelect = (id) => {
    setSelectedPayment(payments.find((payment) => payment.id === id))
    setShowActions(true)
  }

  const handleRequestCancel = () => {
    setConfirmCancel(true)
    setShowActions(false)
  }

  const handleOnUpdate = () => {
    setShowActions(false)
    history.replace(`${history.location.pathname}/${selectedPayment?.id}`)
  }

  const handleOnClose = () => {
    setShowActions(false)
  }

  const onUserDidCancel = () => {
    setSelectedPayment(undefined)
    setConfirmCancel(false)
  }

  const onUserDidConfirm = () => {
    removePayment(orderId, selectedPayment?.id)
    setConfirmCancel(false)
  }

  let cancelDialog = null
  let paymentActionsDialog = null

  if (cancel) {
    cancelDialog = (
      <ConfirmDialog
        title='Cancel Tender?'
        message={`You are about to cancel a Card Tendered for ${centsToDollars(
          selectedPayment.amountInCents
        )}.\nThere will be a remaining balance of ${centsToDollars(
          remainingBalanceInCents + selectedPayment.amountInCents
        )}`}
        cancelButtonText='Nevermind'
        confirmButtonText='Yes, Cancel'
        onCancel={onUserDidCancel}
        onConfirm={onUserDidConfirm}
        className={dialogClassName}
      />
    )
  }

  if (showActions) {
    paymentActionsDialog = (
      <PaymentActionDialog
        title={selectedPayment?.label}
        message='What would you like to do with this tender?'
        onCancel={handleRequestCancel}
        onUpdate={handleOnUpdate}
        onClose={handleOnClose}
        className={dialogClassName}
      />
    )
  }

  return (
    <>
      <PaymentsList
        payments={payments}
        selectedPaymentId={paymentId}
        disabled={paymentId !== undefined}
        onSelect={handleOnSelect}
      />
      {cancelDialog}
      {paymentActionsDialog}
    </>
  )
}

const mapStateToProps = (state, props) => {
  const orderId = props?.match?.params?.orderId
  const paymentId = props?.match?.params?.paymentId
  const getOrder = makeGetOrder()
  const order = TabOrderDetailsViewModel(getOrder(state, orderId))
  const isMultiPayment = order.isMultiPayment
  const payments = isMultiPayment ? filterValidPayments({ payments: order.payments }) : []

  return {
    orderId,
    paymentId,
    isMultiPayment: order.isMultiPayment,
    remainingBalanceInCents: order.remainingBalanceInCents,
    payments
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentsListContainer))
